import { useState, useEffect } from "react";
// import { Container, ChartLabel, StyledSvg } from "./styles";
import React from "react";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  container: {
    position: "relative",
  },
  chartLabel: {
    position: "absolute",
    textAlign: "center",
    width: "100%",
    top: "30px",

    "& .chart-logo": {
      maxWidth: "350px",
      position: "relative",
      left: "-44px",
    },

    "& .chart-title": {
      display: "flex",
      flexDirection: "column",
      whiteSpace: "nowrap",
      position: "relative",
      top: "30px",

      "&.big-label": {
        top: "56px",
        padding: "8px 16px",

        "& .chart-value": {
          fontSize: "1.7rem",
        },
      },
    },

    "& .chart-label": {
      color: theme?.colors?.presale?.cardTitle,
      fontWeight: "normal",
    },

    "& .chart-value": {
      color: theme?.colors?.presale?.cardTitle,

      fontWeight: "bold",
    },
  },
  svgStyles: {
    transform: (props) =>
      `rotate(-90deg) ${props.scale ? `scale(${props.scale})` : ""}`,
    animation: "animateChart 1s linear forwards",
    "& .circle": {
      strokeDasharray: 658,
    },
    "& @keyframes animateChart": {
      from: {
        strokeDashoffset: 658,
      },
      to: {
        strokeDashoffset: (props) => props.strokeOffset,
      },
    },
  },
});

const CHART_CIRCUMFERENCE = 658;

const DoughnutChart = ({
  classes,
  type,
  label,
  value,
  scale,
  percentageComplete,
}) => {
  const [strokeOffset, setStrokeOffset] = useState(CHART_CIRCUMFERENCE);

  useEffect(() => {
    const newStrokeOffset = Math.round(
      CHART_CIRCUMFERENCE - (CHART_CIRCUMFERENCE / 100) * percentageComplete
    );
    setStrokeOffset(newStrokeOffset);
  }, [percentageComplete]);

  return (
    <div className={classes.container}>
      <div className={classes.chartLabel}>
        <div className={`chart-title ${type === "global" ? "big-label" : ""}`}>
          <span className="chart-label">{label}</span>
          <span className="chart-value">{value}</span>
        </div>
        {type !== "global" && (
          <img
            className="chart-logo"
            src={`/images/${type}-badge.png`}
            alt={type}
          />
        )}
      </div>
      <svg
        className={classes.svgStyles}
        strokeOffset={strokeOffset}
        width="260"
        height="260"
        xmlns="http://www.w3.org/2000/svg"
        scale={scale}
      >
        <g>
          <title>Layer 1</title>
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#246bff" />
              <stop offset="35%" stopColor="#6295ff" />
              <stop offset="67%" stopColor="#91b4ff" />
              <stop offset="100%" stopColor="#e5eeff" />
              {/* <stop offset="67%" stopColor="#F100D9" /> */}
              {/* <stop offset="83%" stopColor="#9A24EC" /> */}
              {/* <stop offset="100%" stopColor="#9A24EC" /> */}
            </linearGradient>
          </defs>

          <circle
            r="104.785485"
            cy="130"
            cx="130"
            strokeWidth="20"
            stroke="#fff"
            fill="none"
          />
          <circle
            className="circle"
            r="104.785485"
            cy="130"
            cx="130"
            strokeWidth="20"
            stroke="url('#gradient')"
            fill="none"
          />
        </g>
      </svg>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(DoughnutChart)));
